import { Navigate } from "react-router-dom";
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { AuthContext } from "./AuthContext";

const AccessLevelRoute = ({ element }) => {
  const { userDivisions } = useContext(AuthContext);
  const userHasPermission = userDivisions.length > 0;

  return userHasPermission ? element : <Navigate to="/unauthorized" />;
};
AccessLevelRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default AccessLevelRoute;
